export const useIsLoading = (...loadingStates: boolean[]): boolean =>
  loadingStates.some((loading) => loading);
